// @flow
import mediatorChannels from "@tvg/mediator";
import { get } from "lodash";
import pushToDataLayer from "../gtmUtils";

type VideoPlayerGTMTypeEvents =
  | "VP_VIDEO_VIEWED"
  | "VP_VIDEO_PLAYED_SUCCESSFULL"
  | "VP_VIDEO_PLAY_CLICKED"
  | "VP_VIDEO_PAUSED"
  | "VP_VIDEO_PLAYED_COMPLETELY"
  | "VP_VIDEO_MUTED_UNMUTED"
  | "VP_VIDEO_SIZE_CHANGED"
  | "VP_VIDEO_TILT_SIZE"
  | "VP_VIDEO_PLAY_ERROR"
  | "VP_VIDEO_LOAD_FAILED";

type VideoPlayerGTMType = {
  type: VideoPlayerGTMTypeEvents,
  payload: {
    gaEventAction?: string,
    gaEventLabel?: string,
    videoTitle?: string,
    videoType?: string,
    videoProvider?: string, // e.g jw_player
    errorType?: string
  }
};

export default () => {
  mediatorChannels.base.subscribe(
    "VP_VIDEO_VIEWED",
    (data: VideoPlayerGTMType) => {
      pushToDataLayer({
        event: "video",
        gaEventCategory: "Video",
        gaEventAction: "Video Viewed",
        gaEventLabel: "education",
        module: "video",
        videoTitle: get(data, "payload.videoTitle"),
        videoType: "education",
        videoProvider: get(data, "payload.videoProvider"),
        errorType: undefined
      });
    }
  );

  mediatorChannels.base.subscribe(
    "VP_VIDEO_PLAYED_SUCCESSFULL",
    (data: VideoPlayerGTMType) => {
      pushToDataLayer({
        event: "video",
        gaEventCategory: "Video",
        gaEventAction: "Video Play Successful",
        gaEventLabel: "education",
        module: "video",
        videoTitle: get(data, "payload.videoTitle"),
        videoType: "education",
        videoProvider: get(data, "payload.videoProvider"),
        errorType: undefined
      });
    }
  );

  mediatorChannels.base.subscribe(
    "VP_VIDEO_PLAY_CLICKED",
    (data: VideoPlayerGTMType) => {
      pushToDataLayer({
        event: "video",
        gaEventCategory: "Video",
        gaEventAction: "Video Play Clicked",
        gaEventLabel: "education",
        module: "video",
        videoTitle: get(data, "payload.videoTitle"),
        videoType: "education",
        videoProvider: get(data, "payload.videoProvider"),
        errorType: undefined
      });
    }
  );

  mediatorChannels.base.subscribe(
    "VP_VIDEO_PAUSED",
    (data: VideoPlayerGTMType) => {
      pushToDataLayer({
        event: "video",
        gaEventCategory: "Video",
        gaEventAction: "Video Paused",
        gaEventLabel: "education",
        module: "video",
        videoTitle: get(data, "payload.videoTitle"),
        videoType: "education",
        videoProvider: get(data, "payload.videoProvider"),
        errorType: undefined
      });
    }
  );

  mediatorChannels.base.subscribe(
    "VP_VIDEO_PLAYED_COMPLETELY",
    (data: VideoPlayerGTMType) => {
      pushToDataLayer({
        event: "video",
        gaEventCategory: "Video",
        gaEventAction: "Video 100pc Played",
        gaEventLabel: "education",
        module: "video",
        videoTitle: get(data, "payload.videoTitle"),
        videoType: "education",
        videoProvider: get(data, "payload.videoProvider"),
        errorType: undefined
      });
    }
  );

  mediatorChannels.base.subscribe(
    "VP_VIDEO_MUTED_UNMUTED",
    (data: VideoPlayerGTMType) => {
      pushToDataLayer({
        event: "video",
        gaEventCategory: "Video",
        gaEventAction: get(data, "payload.gaEventAction"),
        gaEventLabel: "education",
        module: "video",
        videoTitle: get(data, "payload.videoTitle"),
        videoType: "education",
        videoProvider: get(data, "payload.videoProvider"),
        errorType: undefined
      });
    }
  );

  mediatorChannels.base.subscribe(
    "VP_VIDEO_SIZE_CHANGED",
    (data: VideoPlayerGTMType) => {
      pushToDataLayer({
        event: "video",
        gaEventCategory: "Video",
        gaEventAction: get(data, "payload.gaEventAction"),
        gaEventLabel: "education",
        module: "video",
        videoTitle: get(data, "payload.videoTitle"),
        videoType: "education",
        videoProvider: get(data, "payload.videoProvider"),
        errorType: undefined
      });
    }
  );

  mediatorChannels.base.subscribe(
    "VP_VIDEO_TILT_SIZE",
    (data: VideoPlayerGTMType) => {
      pushToDataLayer({
        event: "video",
        gaEventCategory: "Video",
        gaEventAction: get(data, "payload.gaEventAction"),
        gaEventLabel: "education",
        module: "video",
        videoTitle: get(data, "payload.videoTitle"),
        videoType: "education",
        videoProvider: get(data, "payload.videoProvider"),
        errorType: undefined
      });
    }
  );

  mediatorChannels.base.subscribe(
    "VP_VIDEO_PLAY_ERROR",
    (data: VideoPlayerGTMType) => {
      pushToDataLayer({
        event: "video",
        gaEventCategory: "Video",
        gaEventAction: "Video Play Error",
        gaEventLabel: get(data, "payload.errorType"),
        module: "video",
        videoTitle: get(data, "payload.videoTitle"),
        videoType: "education",
        videoProvider: get(data, "payload.videoProvider"),
        errorType: get(data, "payload.errorType")
      });
    }
  );

  mediatorChannels.base.subscribe(
    "VP_VIDEO_LOAD_FAILED",
    (data: VideoPlayerGTMType) => {
      pushToDataLayer({
        event: "video",
        gaEventCategory: "Video",
        gaEventAction: "Video Load Failed",
        gaEventLabel: get(data, "payload.errorType"),
        module: "video",
        videoTitle: get(data, "payload.videoTitle"),
        videoType: "education",
        videoProvider: get(data, "payload.videoProvider"),
        errorType: get(data, "payload.errorType")
      });
    }
  );
};
